import {
  FileText,
  MonitorDot,
  PackagePlus,
  ScrollText,
  UserRound,
  Settings,
  FileQuestion,
  Wallet,
  Gift,
  Plug,
} from "lucide-react";

const menuData: any = [
  {
    label: "menu",
    isTitle: true,
  },
  {
    id: "dashboard",
    label: "Dashboard",
    icon: <MonitorDot />,
    link: "/",
    parentId: 2,
  },
  {
    id: "games",
    label: "Manage Games",
    icon: <PackagePlus />,
    parentId: 2,
    subItems: [
      {
        id: "Category",
        label: "Games Category",
        link: "/game-categories",
        parentId: "games",
      },
      {
        id: "games",
        label: "All Games",
        link: "/games",
        parentId: "games",
      },
      {
        id: "games",
        label: "Game Slots",
        link: "/game-slots",
        parentId: "games",
      },
    ],
  },
  {
    id: "trivia",
    label: "Trivia",
    icon: <FileQuestion />,
    parentId: 2,
    subItems: [
      {
        id: "questions",
        label: "Game Questions",
        link: "/trivia",
        parentId: "trivia",
      },
      {
        id: "questions-set",
        label: "Questions Set",
        link: "/questions-set",
        parentId: "trivia",
      },
    ],
  },
  {
    id: "draws",
    label: "Manage Draws",
    link: "/auto-draw",
    icon: <PackagePlus />,
  },
  {
    id: "tickets",
    label: "Tickets",
    icon: <ScrollText />,
    link: "/tickets",
    parentId: 2,
  },
  {
    id: "winners",
    label: "Winners ",
    icon: <FileText />,
    link: "/winners",
    parentId: 2,
  },
  {
    id: "transactions",
    label: "Transactions",
    icon: <Wallet />,
    link: "/transactions",
    parentId: 2,
  },
  {
    id: "merchant-reward-engine",
    label: "Reward engine",
    icon: <Gift />,
    link: "/merchant-reward-engine",
    parentId: 2,
  },
  {
    id: "merchant-business",
    label: "Business & vouchers",
    icon: <Gift />,
    link: "/merchant-business",
    parentId: 2,
  },
  {
    id: "merchant-api",
    label: "API & VAS",
    icon: <Plug />,
    link: "/merchant-api",
    parentId: 2,
  },
  {
    id: "Players",
    label: "Players",
    icon: <UserRound />,
    link: "/players",
    parentId: 2,
  },
  {
    label: "Others",
    isTitle: true,
  },
  {
    id: "profile",
    label: "Profile",
    icon: <Settings />,
    link: "/user-profile",
    parentId: 2,
  },
];

export { menuData };
